import React from 'react';
import { Row, Col } from 'antd';
import { Footer } from './Footer';
import { ActionPlansSection } from './ActionPlansSection';
import { GeneralInformationSummary } from '../GeneralInformationSummary';

export function ActionPlans() {
	return (
		<Row gutter={[0, 32]}>
			<Col span={24}>
				<GeneralInformationSummary />
			</Col>
			<Col span={24}>
				<ActionPlansSection />
			</Col>
			<Col span={24}>
				<Footer />
			</Col>
		</Row>
	);
}
